import { matchesDeliveryPreview } from './deliveryFeeDisplay'
import { useEffect, useState } from 'react'
import { API } from './interceptor'

// Keep basket previews local: an old venue/request must not replace newer totals.
export default function useDeliveryFeePreview(
  venueId,
  orders,
  busy,
  relationships,
) {
  const key = JSON.stringify([
    venueId,
    orders.map(order => [
      order._id,
      order.quantity,
      order.specialProductPrice,
      order.brakesPrice,
      order.product?.price,
    ]),
  ])
  const [preview, setPreview] = useState(null)
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let cancelled = false
    setPreview(null)
    if (!venueId || busy) return
    API.get('api', `venue/${venueId}/pending-order-summary`)
      .then(data => {
        if (!cancelled)
          setPreview(
            matchesDeliveryPreview(orders, data)
              ? { key, data }
              : { key, error: true },
          )
        return data
      })
      .catch(() => {
        if (!cancelled) setPreview({ key, error: true })
      })
    return () => {
      cancelled = true
    }
  }, [venueId, key, busy, relationships, attempt])
  const current = !busy && preview?.key === key ? preview : null
  return {
    summary: current?.data,
    loading: !current,
    error: current?.error,
    retry: () => setAttempt(value => value + 1),
  }
}
